import { RpcError } from "grpc-web";
import {
  GetArtistsForUserOfTracksRequest,
  GetArtistsForUserOfTracksResponse,
  GetCollaboratorsForUserOfTracksRequest,
  GetCollaboratorsForUserOfTracksResponse,
  GetUserRequest,
  GetUserResponse,
  GetUsernamesRequest,
  GetUsernamesResponse,
  GetUsersRequest,
  GetUsersResponse,
  UpdateLastActiveRequest,
  UpdateLastActiveResponse,
} from "../proto/api_pb";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { backOff } from "exponential-backoff";

export const getUser = async (
  token: string,
  userId: string
): Promise<RpcError | GetUserResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetUserRequest();
    request.setUserId(userId);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<GetUserResponse | RpcError>((resolve, reject) => {
          ommuseClient.getUser(request, metadata, function (err, response) {
            if (err) {
              reject(err);
            } else {
              resolve(response);
            }
          });
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const getPublicUser = async (
  token: string,
  userId: string
): Promise<RpcError | GetUserResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetUserRequest();
    request.setUserId(userId);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<GetUserResponse | RpcError>((resolve, reject) => {
          ommuseClient.getPublicUser(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const getAllUsers = async (): Promise<
  RpcError | GetUsernamesResponse | undefined
> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetUsernamesRequest();
    const metadata = {
      "Access-Control-Allow-Origin": "*",
    };

    return await backOff(
      () =>
        new Promise((resolve, reject) => {
          ommuseClient.getUsernames(
            request,
            metadata,
            async function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (er) {
    console.log(er);
  }
};

export const getUsers = async (
  isFeaturedArtists: boolean,
  limit: number,
  page: number,
  genresList: string[],
  searchQuery: string
): Promise<RpcError | GetUsersResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetUsersRequest();
    request.setIsFeatured(isFeaturedArtists);
    request.setLimit(limit);
    request.setPage(page);
    request.setGenresList(genresList);
    request.setSearchQuery(searchQuery);

    const metadata = {
      "Access-Control-Allow-Origin": "*",
    };

    return await backOff(
      () =>
        new Promise((resolve, reject) => {
          ommuseClient.getUsers(
            request,
            metadata,
            async function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (er) {
    console.log(er);
  }
};

export const getArtistsForUser = async (
  userId: string,
  token: string
): Promise<RpcError | GetArtistsForUserOfTracksResponse | undefined> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new GetArtistsForUserOfTracksRequest();
  request.setUserId(userId);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };

  return await backOff(
    () =>
      new Promise<GetArtistsForUserOfTracksResponse | RpcError>(
        (resolve, reject) => {
          ommuseClient.getArtistsForUserOfTracks(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }
      ),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const getCollaboratorsForUser = async (
  userId: string,
  token: string
): Promise<RpcError | GetCollaboratorsForUserOfTracksResponse | undefined> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new GetCollaboratorsForUserOfTracksRequest();
  request.setUserId(userId);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };

  return await backOff(
    () =>
      new Promise<GetCollaboratorsForUserOfTracksResponse | RpcError>(
        (resolve, reject) => {
          ommuseClient.getCollaboratorsForUserOfTracks(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }
      ),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};
export const handleLastActive = async (
  userId: string,
  token: string,
  enterpriseId: string,
  sessionDurationSeconds: number = 0
): Promise<RpcError | UpdateLastActiveResponse | undefined> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new UpdateLastActiveRequest();
  request.setUserId(userId);
  request.setEnterpriseId(enterpriseId);
  request.setSessionDurationSeconds(sessionDurationSeconds);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<UpdateLastActiveResponse | RpcError>(
        (resolve, reject) => {
          ommuseClient.updateLastActive(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }
      ),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );

};


export const checkEnterpriseAddendumAccepted = async (
  token: string
): Promise<boolean> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new UpdateLastActiveRequest();
    const metadata = { Authorization: `${token}`, "Access-Control-Allow-Origin": "*" };
    const response = await new Promise<UpdateLastActiveResponse | RpcError>(
      (resolve, reject) => {
        (ommuseClient as any).checkEnterpriseAddendum(request, metadata, (err: any, res: any) => {
          if (err) reject(err);
          else resolve(res);
        });
      }
    );
    if (response instanceof UpdateLastActiveResponse) {
      return response.getMessage() === "true";
    }
    return false;
  } catch {
    return false;
  }
};

export const acceptEnterpriseAddendum = async (
  token: string
): Promise<void> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new UpdateLastActiveRequest();
  const metadata = { Authorization: `${token}`, "Access-Control-Allow-Origin": "*" };
  await new Promise<void>((resolve, reject) => {
    (ommuseClient as any).acceptEnterpriseAddendum(request, metadata, (err: any) => {
      if (err) reject(err);
      else resolve();
    });
  });
};
